import React from 'react'
import Head from 'next/head'
import BottomCTA from '@src/pages/common/components/BottomCTA'
import Clients from '../LandingPage/Clients'
import Pitch from '../LandingPage/Pitch'
import B2bTestimonials from './B2bTestimonials'
import BusinessServices from './BusinessServices'
import Sustainability from './Sustainability'
import WhyDimension from './WhyDimension'

const B2BSolutions = () => {
  return (
    <>
      <Head>
        <link rel="canonical" href="https://getdimension.com/b2b-solutions" />
        <title>
          Commercial Waste Management Services - Recurring Rentals and Removals | Dimension
        </title>
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <meta name="description" content="Boost your business's sustainability with our innovative waste management services, designed to increase diversion and minimize environmental impact." />
      </Head>
      <Pitch isBusiness />
      <WhyDimension />
      <Clients isB2b />
      <BusinessServices />
      <B2bTestimonials />
      <Sustainability />
      <BottomCTA isB2b isProviderPortal={false} />
    </>
  )
}

export default B2BSolutions
